<template>
  <v-expansion-panels v-model="panel" class="mt-3">
    <v-expansion-panel elevation="0" rounded="lg">
      <v-expansion-panel-title height="48px" style="background-color: #7077bb4D">
        <span class="reg-normal">{{ $store.getters.translate('log') }} ({{ logs.length }})</span>
        <template #actions="{ expanded }">
          <v-icon size="large" :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"/>
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-list v-if="logs && logs.length > 0" density="compact">
          <template v-for="log in logs">
            <v-list-item color="primary">
              <v-list-item-title>
                <span class="sm-normal text-primary">{{ log.message }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="tiny-normal">{{ log.creator + ' on ' + moment(log.timestamp, "DD-MM-YYYY HH:mm:ss").format("D MMMM YYYY HH:mm:ss") }}</span>
              </v-list-item-subtitle>
            </v-list-item>
            <v-divider/>
          </template>
        </v-list>
        <div class="reg-normal text-primary mt-3" v-else>{{ $store.getters.translate("nothing_found") }}</div>
        <v-text-field
            v-if="!isDisabled"
            density="default"
            class="reg-normal text-primary mt-5"
            base-color="border-tertiary"
            bg-color="secondary"
            color="primary"
            v-model="new_message"
            @keyup.enter="insertContent()"
            hide-details
            single-line
            flat
            clearable>
          <template v-if="button_location === 'inline'" #label>
            <span class="sm-normal text-subtle">{{ $store.getters.translate('add_to_log') }}</span>
          </template>
          <template v-if="button_location === 'inline'" #append>
            <base-action-button @click="insertContent()">
              <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate('add') }}
            </base-action-button>
          </template>
        </v-text-field>
        <base-action-button v-if="!isDisabled && button_location === 'bottom'" class="mt-5" @action="insertContent">
          <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("add") }}
        </base-action-button>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import moment from "moment";
import BaseActionButton from "./BaseActionButton";
import {PhPlus} from "@phosphor-icons/vue";

export default {
  components: {PhPlus, BaseActionButton},
  props: ["model_id", "model_type", "isDisabled", "button_location", "expand"],
  data() {
    return {
      page: helpFunctions.pages.modellogs,
      logs: [],
      new_message: null,
      panel: []
    };
  },
  mounted() {
    if(this.expand) {
      this.panel = [0];
    }
    this.load();
  },
  methods: {
    async load() {
      if(this.model_id) {
        this.logs = [];
        let response = await helpFunctions.getCustomRoute(this.$toast, this.page.name + "?model_type=" + this.model_type + "&model_id=" + this.model_id);
        let temp_logs = response.split("\n");
        for (let i = 0; i < temp_logs.length; i++) {
          if(temp_logs[i] !== "") {
            let parts = temp_logs[i].split("]", 2);
            this.logs.push({
              timestamp: parts[0].split(" - ")[0].replace("[", ""),
              creator: parts[0].split(" - ")[1],
              message: parts[1],
            });
          }
        }
      }
    },
    async insertContent() {
      if (this.new_message) {
        this.logs.unshift({
          timestamp: moment().format("DD-MM-YYYY HH:mm:ss"),
          creator: this.$store.getters.getUser.person.casual_name,
          message: this.new_message,
        });

        let new_message_signed = "[" + moment().format("DD-MM-YYYY HH:mm:ss") + " - " + this.$store.getters.getUser.person.casual_name + "] " + this.new_message;

        await helpFunctions.createModel(this.$toast, this.page.name, {
          model_id: this.model_id,
          model_type: this.model_type,
          new_message_signed: new_message_signed,
        });

        //USED AT PUNCHLIST ITEMS EDIT PAGE ONLY
        this.$emit('update', this.new_message);

        this.new_message = null;
      }
    },
  },
  watch: {
    model_id: {
      handler() {
        this.load();
      },
    },
  },
};
</script>